import {Config, Environment} from "./config";

export const prod: Config = {
    environment: Environment.PROD,
    showEnvLabel: false,
    server: "https://backend.eevie.pet.cloud.audi",
}